import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { AppConstants } from 'src/app/commons/app-constants';

@Injectable({ providedIn: 'root' })
export class BetaService {
  private readonly betaModeSubject = new BehaviorSubject<boolean>(false);
  readonly betaMode$ = this.betaModeSubject.asObservable();

  private loaded = false;

  constructor(private http: HttpClient) {}

  get betaMode(): boolean {
    return this.betaModeSubject.value;
  }

  load(): void {
    if (this.loaded) return;
    this.loaded = true;
    this.http
      .get<{ betaMode: boolean }>(`${AppConstants.API_URL}api/v1/app/beta`)
      .subscribe({
        next: (res) => this.betaModeSubject.next(res.betaMode),
        error: () => { /* silently ignore — beta badge stays hidden */ },
      });
  }

  refresh(): void {
    this.loaded = false;
    this.load();
  }

  setFromBootstrap(betaMode: boolean): void {
    this.loaded = true;
    this.betaModeSubject.next(betaMode);
  }
}
